.square-grid {
    display: grid;
    grid-template-columns: repeat(var(--square-grid-columns), 1fr);
    grid-auto-rows: 1fr;
    place-items: center center;
}

.square-grid .cell {
    width: 100%;
    display: grid;
    position: relative;
}

.square-grid .cell::before {
    content: '';
    padding-bottom: 100%;
}

.square-grid .item {
    position: absolute;
    width: 100%;
    height: 100%;
}
